import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { motion } from "framer-motion";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
// import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { vehicleInformationValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { toast } from "core/Operations/toast";
import { useInsertVehicleInformationMutation } from "AppQuries/master/VehicleInformation/vehicleinformation";
import Vehicle from "./Tab/Vehicle";
import VehicleExpenses from "./Tab/VehicleExpense";
import VehicleMaintenance from "./Tab/VehicleMaintenance";
import DieselUsage from "./Tab/DieselUsage";
import VehicleAccident from "./Tab/Accident";
import VehicleIndemnity from "./Tab/Indemnity";
import { Popconfirm } from "antd";
import { VehicleInformationMapping } from "./VehicleInformationMapping";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import { BackIcon } from "Components/UI/Icon/Icons";

const steps = [
  { id: 0, name: "Information", component: Vehicle },
  { id: 1, name: "Expenses", component: VehicleExpenses },
  { id: 2, name: "Maintenance", component: VehicleMaintenance },
  { id: 3, name: "Diesel", component: DieselUsage },
  { id: 4, name: "Accident", component: VehicleAccident },
  { id: 5, name: "Indemnity", component: VehicleIndemnity },
];

const AddInsuranceType = () => {
  const userData = useSelector(loggedInUser);
  const [step, setStep] = useState(0);
  const {
    mutate: insertVehicleInformation,
    isPending,
    isError,
    error,
  } = useInsertVehicleInformationMutation();
 
  const vehicleMethods = useForm({
    defaultValues: {
      vehicleInformationList: [
        {
          vehicleNumber: "",
          companyCode: userData?.companyCode,
          vehicleName: "",
          vehicleType: "",
          company: "",
          department: "",
          iuLabelNumber: "",
          chassisNumber: "",
          vehicleModel: "",
          vehicleCategory: "",
          propellant: "",
          status: "",
          assetTagNo: "",
          gpsSimNo: "",
          requireTill: "",
          registerDate: "",
          fine: 0,
          vehicleBelongsTo: "",
          category: "",
          remarks: "",
          cost: 0,
          purchaseCost: 0,
          purchaseFrom: "",
          purchaseDate: "",
          coeCost: 0,
          coeExpiryDate: "",
          driverName: "",
          driverContactNo: "",
          statusNationalityAndWPSPass: "",
          jobSite: "",
          jobNumber: "",
          dieselAmount: 0,
          dieselTopupAmount: 0,
          rentalDriverCost: 0,
          rentalVehicleCost: 0,
          createUser: userData?.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData?.userName,
          modifyDate: getCurrentFormattedDate(),
          isActive: true,
        },
      ],
      vehicleExpensesList: [
        {
          expenseID: 0,
          companyCode: userData?.companyCode,
          vehicleNumber: "",
          insuranceNumber: "",
          insurancePeriod: "",
          insuranceAmount: 0,
          insuranceVendor: "",
          insuranceAgency: "",
          insuranceExpiryDate: "",
          craneInsuranceExpiryDate: "",
          lorryCraneLMCertExpiryDate: "",
          lgNextDueDate: "",
          roadTaxDueDate: "",
          inspectionDueDate: "",
          roadTaxInspectionAmount: 0,
          roadTaxInvRef: "",
          ncd: "",
          remarks: "",
          parkingNextDueDate: "",
          vpc: "",
          vpcAmount: 0,
          vpcAddress: "",
          parkingVendor: "",
          parkingLocation: "",
          parkingAmount: 0,
          parkingCouponNextDueDate: "",
          parkingAddress: "",
          parkingPaymentMode: "",
          fmtDueDate: "",
          fmtAmount: 0,
          shellCardNo: "",
          shellPIN: "",
          createUser: userData?.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData?.userName,
          modifyDate: getCurrentFormattedDate(),
          isActive: true,
        },
      ],
      vehicleAccidentList: [],
      dieselUsageList: [],
      vehicleMaintenanceList: [],
      vehicleIndemnityList: [],
    },
    
    resolver: yupResolver(vehicleInformationValidationSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
    watch,
  } = vehicleMethods;

  const StepComponent = steps[step].component;

  const moveTo = async (id) => {
    setStep(id);
  };

  const onSubmit = (payload) => {
    console.log(payload);
    insertVehicleInformation(payload, {
      onSuccess: (data) => {
        if (data?.result) {
          toast.success(data?.message || "Added Successfully.");
          setTimeout(() => {
            navigate(
              `${all_routes.vechile_master}${all_routes.vehicleinformation}`
            );
          }, 1000);
        } else {
          toast.warning(data?.message || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const onError = (errors) => {
    // Get the first field with error
    const firstErrorField = Object.keys(errors)[0];
    const tabIndex = VehicleInformationMapping[firstErrorField];

    if (tabIndex !== undefined) {
      setStep(tabIndex);
    }
  };

  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...vehicleMethods}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Vehicle Information</h4>
                  </div>
                </div>
               
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save Vehicle Information
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                 <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Popconfirm
                      title="Are you sure to go back before saving?"
                      onConfirm={() =>
                        navigate(
                          `${all_routes.vechile_master}/${all_routes.vehicleinformation}`
                        )
                      }
                    >
                      <button type="button" className="btn btn-secondary">
                        <BackIcon className="me-2" />
                        Back
                      </button>
                    </Popconfirm>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-solid nav-justified mb-3">
                        {steps?.map((item, index) => (
                          <li className="nav-item me-0" key={item.id}>
                            <Link
                              className={`nav-link step-${item.id} py-1 ${
                                index === step
                                  ? "active"
                                  : index < step
                                  ? "completed"
                                  : "in-completed"
                              }`}
                              id={item.id}
                              type="button"
                              // disabled
                              onClick={() => moveTo(item.id)}
                            >
                              {/* <motion.div
                                className={`w-10 h-10 mx-auto flex items-center justify-center font-bold rounded-full transition`}
                                initial={{ scale: 0.9 }}
                                animate={{ scale: index === step ? 1.1 : 1 }}
                                transition={{ duration: 0.9 }}
                              > */}
                              {item.name}
                              {/* </motion.div> */}
                            </Link>
                          </li>
                        ))}
                      </ul>
                      <div className="tab-content">
                        <motion.div
                          key={step}
                          initial={{ opacity: 0, x: 50 }}
                          animate={{ opacity: 1, x: 0 }}
                          exit={{ opacity: 0, x: -50 }}
                          transition={{ duration: 0.3 }}
                        >
                          <div className="tab-pane text-editor add-list">
                            <StepComponent
                              companyCode={userData?.companyCode}
                            />
                          </div>
                        </motion.div>
                        {/* <div className="tab-pane show active" id="tab1">
                          <Vehicle companyCode={userData?.companyCode} />
                        </div>
                        <div className="tab-pane" id="tab2">
                          <VehicleExpenses />
                        </div>
                        <div className="tab-pane" id="tab3">
                          <VehicleMaintenance />
                        </div>
                        <div className="tab-pane" id="tab4">
                          <DieselUsage />
                        </div>
                        <div className="tab-pane" id="tab5">
                          <VehicleAccident />
                        </div>
                        <div className="tab-pane" id="tab6">
                          <VehicleIndemnity />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddInsuranceType;
